import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_LINK; // 🔁 replace with actual domain in production

const NewLaunch = () => {
    const [latestProperties, setLatestProperties] = useState([]);
    const navigate = useNavigate();
        const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";

    const fetchRecentProperties = async () => {
        try {
            const [res1, res2, res3] = await Promise.all([
                fetch(`${BASE_URL}/resident/getproperty/HBTR0001`),
                fetch(`${BASE_URL}/commercial/getproperty/HBTR0001`),
                fetch(`${BASE_URL}/rentresident/getproperty/HBTR0001`)
            ]);

            const [json1, json2, json3] = await Promise.all([
                res1.json(),
                res2.json(),
                res3.json()
            ]);

            const parseJSON = (val) => {
                try {
                    return typeof val === 'string' ? JSON.parse(val) : val;
                } catch {
                    return val;
                }
            };

            const combined = [
                ...json1.map(item => ({ ...item, formImages: parseJSON(item.formImages || "[]") })),
                ...json2.map(item => ({ ...item, formImages: parseJSON(item.formImages || "[]") })),
                ...json3.map(item => ({ ...item, formImages: parseJSON(item.formImages || "[]") })),
            ];

            const unique = combined.filter((v, i, arr) =>
                i === arr.findIndex((t) => t.property_id === v.property_id)
            );

            const sorted = unique.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            const recent = sorted.slice(0, 3); // latest 3

            setLatestProperties(recent);
        } catch (err) {
            console.error("Error fetching new launches:", err);
        }
    };

    useEffect(() => {
        fetchRecentProperties();
    }, []);

    return (
        <div className="big-house-new-launch-section">
            <h2>New Launch Projects</h2>
            <p>We help you find where your story begins. Let’s turn your dreams into an address.</p>

            <div className="big-house-new-launch-cards">
               {latestProperties.map((property, index) => {
    const flatType = Array.isArray(property.flatType)
        ? property.flatType
        : (() => {
            try {
                return JSON.parse(property.flatType || "[]");
            } catch {
                return [];
            }
        })();

    // Extract prices
    let prices = [];
    flatType.forEach(ft => {
        if (Array.isArray(ft.builtUpAreas)) {
            ft.builtUpAreas.forEach(area => {
                const price = parseFloat(area?.expectedPrice);
                if (!isNaN(price)) prices.push(price);
            });
        }
    });

    const minPrice = Math.min(...prices);
    const maxPrice = Math.max(...prices);
    const formatPrice = (p) => `₹ ${p.toLocaleString('en-IN')}`;

    return (
        <div className="big-house-new-launch-card" key={property.property_id}>
            <img
                src={`${BASE_URL}/Images/Store/${property.formImages?.[0] || "placeholder.jpg"}`}
                alt={property.building_name}
                className="big-house-new-launch-img"
            />
            <div className="big-house-new-launch-content">
                <h3>{property.building_name}</h3>
                <div className="big-house-new-launch-card-price-flex">
                    <p>
                        {prices.length === 0
                            ? "Price on Request"
                            : minPrice === maxPrice
                                ? formatPrice(minPrice)
                                : `${formatPrice(minPrice)} - ${formatPrice(maxPrice)}`
                        }
                    </p>
                    <button onClick={() => {
                        if (property.typeofproperty === "Residential") {
                            navigate(`/residential-property/${property.property_id}`);
                        } else if (property.typeofproperty === "Commercial") {
                            navigate(`/commercial-property/${property.property_id}`);
                        } else {
                            navigate(`/rent-property/${property.property_id}`);
                        }
                    }}>
                        Explore Now
                    </button>
                </div>
            </div>
        </div>
    );
})}

            </div>

            <div className="big-house-view-all-properties">
                <button onClick={() => navigate("/my-projects")}>View More</button>
            </div>
        </div>
    );
};

export default NewLaunch;
